module.exports = __webpack_public_path__ + "76004d73dafd2d93f497e755d5923f0f.svg";